module.exports = __webpack_public_path__ + "assets/img/daily_task_bg.1de4b041.png";